import * as React from 'react';

import { IBank } from '../../types/bank';

import { AccreditedBanks } from './AccreditedBanks';
import { trackAccreditedBanksToListingClick } from './tracking';
import { useMortgageCalculatorContext } from '../../contexts/MortgageCalculatorContext';

export const AccreditedBanksContainer: React.FC = () => {
  const { banks } = useMortgageCalculatorContext();

  const handleBankClick = React.useCallback<(bank: IBank) => void>(bank => {
    trackAccreditedBanksToListingClick(bank);
  }, []);

  if (!banks.length) {
    return null;
  }

  return <AccreditedBanks banks={banks} onBankClick={handleBankClick} />;
};
